import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  from?: 'failed';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/payments/invoices_/$id')({
  staticData: {
    team: 'payments',
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    // TODO: validate any of these search params
    return search;
  },
});
